
<template>
  <div
    style="width: 100vw;
    top: 0;
    height: 100vh;
    position: fixed;
    z-index: 1;
    top: 64px;
    overflow-y: scroll;">
    <div class="return-header" @click="back">
      <img src="../assets/ExpandMore1.svg" style="margin-right: 10px;"> Назад к меню
    </div>
    <div class="k-article k-card k-article-subscribe">
      <div class="k-subscribe__loading-wrapper" v-if="isLoading">
        <k-spinner />
      </div>
      <div class="k-article__image-wrapper" style="position: relative;">
        <div class="k-image__overblock">
          <img class="k-article__img" :src="getCurrentStaticData.image" />
        </div>
        <div class="k-article__footer-always d-block">
          <div :class="['d-flex', 'flex-wrap', {'justify-content-end': special || !bought}, {'justify-content-between': !special && !bought}]">
            <div class="k-article__info-button" v-if="!special">1 300 - 1 600 ККАЛ</div>
            <template v-if="!getCurrentStaticData.notForSale">
            <div
                v-if="!bought && getCurrentStaticData.lock && getCurrentStaticData.buyLink"
                @click="open(getCurrentStaticData.buyLink)"
                class="k-article__buy-button ml-2"
            >Купить</div>
            <div
                v-if="!bought"
                @click="buy"
                class="k-article__buy-button ml-2"
            >{{ getCurrentButtonText }}</div>
            </template>
          </div>
          <div class="k-article__nav-buttons" v-if="false">
            <div class="k-article__nav-button k-article__nav-button-left">
              <svg
                class="k-article__nav-button-img"
                width="5"
                height="8"
                viewBox="0 0 5 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.87569 7.33123L1.11878 4L4.87569 0.66877C5.04144 0.51735 5.04144 0.264984 4.87569 0.113565C4.70994 -0.0378549 4.4337 -0.0378549 4.21271 0.113565L0.124309 3.69716C-0.0414365 3.84858 -0.0414365 4.10095 0.124309 4.25237L4.15746 7.88644C4.3232 8.03786 4.59945 8.03786 4.82044 7.88644C5.04144 7.73502 5.04144 7.48265 4.87569 7.33123Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="k-article__nav-button k-article__nav-button-right">
              <svg
                class="k-article__nav-button-img"
                width="5"
                height="8"
                viewBox="0 0 5 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.124309 0.668769L3.88122 4L0.12431 7.33123C-0.0414358 7.48265 -0.0414357 7.73502 0.12431 7.88644C0.290056 8.03786 0.566299 8.03786 0.787293 7.88644L4.87569 4.30284C5.04144 4.15142 5.04144 3.89905 4.87569 3.74763L0.842541 0.113564C0.676795 -0.0378548 0.400553 -0.0378547 0.179558 0.113564C-0.0414364 0.264984 -0.0414364 0.51735 0.124309 0.668769Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="k-article__content" style="margin-bottom: 150px;">
        <div class="k-article__title-wrapper" style="margin: 10px 0 24px;">
          <div class="k-article__title">{{ getCurrentStaticData.title }}</div>
          <div class="k-article__badges" v-if="getCurrentStaticData.tags">
            <span class="k-badge badge k-badge-yellow mr-1">{{ getCurrentStaticData.tags[0] }}</span>
            <span class="k-badge badge k-badge-red mr-1">{{ getCurrentStaticData.tags[1] }}</span>
            <span class="k-badge badge k-badge-green">{{ getCurrentStaticData.tags[2] }}</span>
          </div>
        </div>
        <div class="k-article__description detail">
          <p v-html="getCurrentStaticData.description"></p>
          <!-- {{ getCurrentStaticData.description }} -->
        </div>
        <div :class="{'k-article__badges':true, 'mobile': true, 'detail': showMore}" v-if="getCurrentStaticData.tags">
          <span class="k-badge badge k-badge-yellow mr-1">{{ getCurrentStaticData.tags[0] }}</span>
          <span class="k-badge badge k-badge-red mr-1">{{ getCurrentStaticData.tags[1] }}</span>
          <span class="k-badge badge k-badge-green">{{ getCurrentStaticData.tags[2] }}</span>
        </div>
        <div
            :class="{'k-article__body': true, 'mb-2': true, 'detail': showMore}"
            v-if="getCurrentStaticData.lists"
            style="opacity: 0.64;"
        >
          <div
              v-for="(list, i) of getCurrentStaticData.lists"
              :key="`subscribe-list-${i}`"
              :class="{'col-6': !showMore}"
          >
            <span class="k-article__body-subtitle text-uppercase">
              {{ list.title }}
            </span>
            <ul class="k-article__body-list">
              <li
                  v-for="item in list.list"
                  :key="item"
                  class="k-article__body-list-item"
              >
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
          <div class="k-article__nav-buttons" v-if="!single" style="align-self: flex-end;">
            <div class="k-article__nav-button k-article__nav-button-left cursor-pointer" @click="$emit('prevSubscribe')">
              <svg
                class="k-article__nav-button-img"
                width="5"
                height="8"
                viewBox="0 0 5 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.87569 7.33123L1.11878 4L4.87569 0.66877C5.04144 0.51735 5.04144 0.264984 4.87569 0.113565C4.70994 -0.0378549 4.4337 -0.0378549 4.21271 0.113565L0.124309 3.69716C-0.0414365 3.84858 -0.0414365 4.10095 0.124309 4.25237L4.15746 7.88644C4.3232 8.03786 4.59945 8.03786 4.82044 7.88644C5.04144 7.73502 5.04144 7.48265 4.87569 7.33123Z"
                  fill="white"
                />
              </svg>
            </div>
            <div class="k-article__nav-button k-article__nav-button-right cursor-pointer" @click="$emit('nextSubscribe')">
              <svg
                class="k-article__nav-button-img"
                width="5"
                height="8"
                viewBox="0 0 5 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.124309 0.668769L3.88122 4L0.12431 7.33123C-0.0414358 7.48265 -0.0414357 7.73502 0.12431 7.88644C0.290056 8.03786 0.566299 8.03786 0.787293 7.88644L4.87569 4.30284C5.04144 4.15142 5.04144 3.89905 4.87569 3.74763L0.842541 0.113564C0.676795 -0.0378548 0.400553 -0.0378547 0.179558 0.113564C-0.0414364 0.264984 -0.0414364 0.51735 0.124309 0.668769Z"
                  fill="white"
                />
              </svg>
            </div>
          </div>
        </div>
        <div :class="{'k-article__body': true, 'detail': showMore}" v-if="getCurrentStaticData.short_description">
          <p v-html="getCurrentStaticData.short_description"></p>
        </div>
        <div v-if="isMobile && getCurrentStaticData.footer" v-html="getCurrentStaticData.footer"></div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import KSpinner from './TheSpinner.vue';

export default {
  data() {
    return {
      showMore: true
    }
  },
  components: {
    KSpinner,
  },
  props: {
    isLoading: Boolean,
    bought: {
      type: Boolean,
      default: true,
    },
    special: Boolean,
    title: {
      type: String,
    },
    menuId: {
      type: String,
      default: '',
    },
    single: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
    }
  },
  methods: {
    buy() {
      if (this.special) {
        this.$root.$emit('buy-subscription-special', this.menuId, this.getCurrentStaticData.lock, this.getCurrentStaticData.free);
      } else {
        this.$root.$emit('buy-subscribe', this.menuId);
      }
    },
    back() {
      this.$emit('get-back');
    },
    open(link) {
      window.open(link, '_blank');
    },
  },
  computed: {
    ...mapGetters([
      'getSubscribesAndSets',
      'getAvaiableUserSets',
      'getAvaiableUserSubscribes',
    ]),
    isMobile() {
      return this.$mq === 'xs' || this.$mq === 'sm';
    },
    getCurrentStaticData() {
      return this.getSubscribesAndSets.find(el => el.id === this.menuId) || this.getSubscribesAndSets[0]
    },
    getCurrentRealData() {
      const current = this.getAvaiableUserSets.concat(this.getAvaiableUserSubscribes);
      const subscribe = current.find(el => el.id === this.menuId);
      return subscribe || {}
    },
    getCurrentButtonText() {
      if (this.special && !this.getCurrentStaticData.lock && !this.getCurrentStaticData.lock && !this.getCurrentStaticData.free) return `Купить за ${this.getCurrentRealData.price} рублей`
      else if (this.getCurrentStaticData.lock) return 'Разблокировать'
      else if (this.getCurrentStaticData.free) return 'Бесплатно'
      else return 'Купить'
    }
  },
}
</script>

<style lang="scss" scoped>
.return-header {
  background-color: white;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 10px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 55px;
}
.k-article {
  &__title {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    //line-height: 5px;
  }
  &__description{
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
  }
  &-subscribe {
    position: relative;
    height: auto;
    min-height: 100%;
  }
  &__body {
    &-subtitle {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
    }
    &-list {
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 24px;
      padding-left: 26px;
      margin: 12px 0 24px;
    }
    // &.spec {
    //   background: #F68C1E;
    //   border-radius: 4px;
    //   padding: 5px 20px;
    //   span {
    //     p {
    //         color: #FFFFFF;
    //     }
    //      font-style: normal;
    //         font-weight: normal;
    //         font-size: 16px;
    //         line-height: 23px;
    //         color: #FFFFFF;
    //     .subscribe__short-text--title {

    //         font-style: normal;
    //         font-weight: normal;
    //         font-size: 16px;
    //         line-height: 23px;
    //       }
    //         // &--default {
    //         //   font-weight: normal;
    //         //   font-size: 12px;
    //         //   line-height: 16px;
    //         //   letter-spacing: -0.5px;
    //         //   color: #FFFFFF;
    //         // }

    //   }
    // }
  }
  &__footer-always {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10px;
  }
  &__detail {
    display: none;
    @media (max-width: 575.98px) {
      font-size: 12px;
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
    }
  }
  &__badges {
    @media (max-width: 575.98px) {
      margin: 16px 0;
    }
  }
}
.k-subscribe__loading-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  opacity: 0.85;
  display: flex;
  justify-content: center;
  align-content: center;
  z-index: 3;
}
.mobile {
  display: none;
}
.detail {
  @media (max-width: 575.98px) {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
